import esContent from './linkNaBio.es';

export default {
  ...esContent,
};
